/**
 * GLAME SKINCARE THEME - MAIN JAVASCRIPT
 * Built with Vanilla JS (No Framework)
 * Shopify Online Store 2.0
 */

/**
 * Fiyat biçimi tek kaynak: kuruş yok, binlik ayracı nokta ("3.999 TL").
 * snippets/money-tr.liquid ile birebir aynı çıktıyı üretir. Bölüm içi satır içi
 * scriptler de kullanabilsin diye IIFE dışında, global olarak tanımlanır.
 */
window.GlameMoney = window.GlameMoney || {
  tl: function (cents, options) {
    var opts = options || {};
    var amount = typeof cents === 'string' ? parseFloat(cents.replace(/[^\d.-]/g, '')) : cents;
    if (!isFinite(amount)) amount = 0;
    var whole = Math.round(amount / 100);
    var grouped = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return opts.currency === false ? grouped : grouped + ' TL';
  }
};

(function () {
  'use strict';

  /**
   * ============================================
   * 1. UTILITY FUNCTIONS
   * ============================================
   */
  document.documentElement.classList.add('js-ready');
  const Utils = {
    /**
     * Debounce function to limit how often a function can fire
     */
    debounce: function (fn, delay = 300) {
      let timeoutId;
      return function (...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => fn.apply(this, args), delay);
      };
    },

    /**
     * Throttle function to limit function execution rate
     */
    throttle: function (fn, delay = 300) {
      let lastCall = 0;
      return function (...args) {
        const now = new Date().getTime();
        if (now - lastCall < delay) return;
        lastCall = now;
        return fn.apply(this, args);
      };
    },

    /**
     * Fiyat biçimi: kuruş gösterilmez, binlik ayracı noktadır.
     * snippets/money-tr.liquid ile aynı sonucu üretir: 399900 -> "3.999 TL"
     * Bölüm içi satır içi scriptler window.GlameMoney.tl() ile aynı işlevi kullanır.
     */
    formatMoney: function (cents, options) {
      return window.GlameMoney.tl(cents, options);
    },

    /**
     * Serialize form data to object
     */
    serializeForm: function (form) {
      const formData = new FormData(form);
      const obj = {};
      for (let [key, value] of formData.entries()) {
        obj[key] = value;
      }
      return obj;
    },

    /**
     * Get CSS variable value
     */
    getCSSVariable: function (variable) {
      return getComputedStyle(document.documentElement).getPropertyValue(variable).trim();
    },

    /**
     * Check if element is in viewport
     */
    isInViewport: function (element) {
      const rect = element.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    },

    /**
     * Get all focusable elements in container
     */
    getFocusableElements: function (container) {
      return Array.from(
        container.querySelectorAll(
          'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      );
    },

    /**
     * Trap focus within element (for modals, drawers)
     */
    trapFocus: function (element) {
      const focusableElements = this.getFocusableElements(element);
      const firstFocusable = focusableElements[0];
      const lastFocusable = focusableElements[focusableElements.length - 1];

      element.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;

        if (e.shiftKey) {
          if (document.activeElement === firstFocusable) {
            lastFocusable.focus();
            e.preventDefault();
          }
        } else {
          if (document.activeElement === lastFocusable) {
            firstFocusable.focus();
            e.preventDefault();
          }
        }
      });
    }
  };

  /**
   * ============================================
   * 2. GLM2 OVERLAY MENU + MOBILE MENU
   * ============================================
   */

  const MobileMenu = {
    init: function () {
      this.overlayMenu = document.getElementById('omenu');
      this.hamburgers = document.querySelectorAll('.hbg, #hbgDesk, #hbgMob');
      this.closeBtn = document.getElementById('omclose');

      /* Legacy support for old mobile menu */
      this.menuToggle = document.querySelector('[data-menu-toggle]');
      this.menu = document.querySelector('[data-mobile-menu]');
      this.menuClose = document.querySelector('[data-menu-close]');
      this.overlay = document.querySelector('[data-menu-overlay]');

      this.bindEvents();
    },

    bindEvents: function () {
      /* GLM2 overlay menu */
      if (this.overlayMenu) {
        this.hamburgers.forEach(btn => {
          btn.addEventListener('click', () => this.openOverlay());
        });
        if (this.closeBtn) {
          this.closeBtn.addEventListener('click', () => this.closeOverlay());
        }
      }

      /* Legacy mobile menu */
      if (this.menuToggle && this.menu) {
        this.menuToggle.addEventListener('click', () => this.open());
        if (this.menuClose) this.menuClose.addEventListener('click', () => this.close());
        if (this.overlay) this.overlay.addEventListener('click', () => this.close());
      }

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          if (this.overlayMenu && this.overlayMenu.classList.contains('open')) this.closeOverlay();
          if (this.menu && this.menu.classList.contains('is-open')) this.close();
        }
      });
    },

    openOverlay: function () {
      this.overlayMenu.classList.add('open');
      this.hamburgers.forEach(btn => btn.classList.add('open'));
      document.body.style.overflow = 'hidden';
      Utils.trapFocus(this.overlayMenu);
    },

    closeOverlay: function () {
      this.overlayMenu.classList.remove('open');
      this.hamburgers.forEach(btn => btn.classList.remove('open'));
      document.body.style.overflow = '';
    },

    open: function () {
      if (!this.menu) return;
      this.menu.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (this.overlay) this.overlay.classList.add('is-visible');
      Utils.trapFocus(this.menu);
    },

    close: function () {
      if (!this.menu) return;
      this.menu.classList.remove('is-open');
      document.body.style.overflow = '';
      if (this.overlay) this.overlay.classList.remove('is-visible');
    }
  };

  /**
   * ============================================
   * 3. CART FUNCTIONALITY (AJAX CART)
   * ============================================
   */

  const Cart = {
    init: function () {
      this.drawer = document.querySelector('[data-cart-drawer]');
      this.overlay = document.querySelector('[data-cart-overlay]');
      this.closeButtons = document.querySelectorAll('[data-cart-close]');
      this.countBubbles = document.querySelectorAll('[data-cart-count]');

      this.bindEvents();
    },

    bindEvents: function () {
      // Open cart drawer
      document.addEventListener('click', (e) => {
        if (e.target.closest('[data-cart-open]')) {
          e.preventDefault();
          
          // Cart sayfasındaysa drawer açma, direkt cart sayfasına git
          const isCartPage = window.location.pathname.includes('/cart');
          if (isCartPage) {
            window.location.href = '/cart';
            return;
          }
          
          this.openDrawer();
        }
      });
      document.addEventListener('click', (e) => {
        if (e.target.closest('[data-cart-close]')) {
          e.preventDefault();
          Cart.closeDrawer();
        }
      });
      // Close cart drawer
      /*
      if (this.closeButtons.length > 0) {

        this.closeButtons.forEach(btn => {
          console.log("this.closeButtons", btn)
          btn.addEventListener('click', () => this.closeDrawer());
        });
      }

      */
      if (this.overlay) {
        this.overlay.addEventListener('click', () => this.closeDrawer());
      }

      // Add to cart forms
      document.addEventListener('submit', (e) => {
        if (e.target.matches('[data-product-form]')) {
          e.preventDefault();
          this.addToCart(e.target);
        }
      });

      // Quantity changes
      document.addEventListener('click', (e) => {
        if (e.target.matches('[data-quantity-minus]')) {
          this.changeQuantity(e.target, -1);
        }
        if (e.target.matches('[data-quantity-plus]')) {
          this.changeQuantity(e.target, 1);
        }
      });

      // Remove item
      document.addEventListener('click', (e) => {
        if (e.target.closest('[data-cart-remove]')) {
          e.preventDefault();
          const lineItem = e.target.closest('[data-cart-item]');
          const key = lineItem.dataset.cartItem;
          this.removeItem(key);
        }
      });
    },

    /**
     * Ürün başına sepet limiti.
     *
     * Shopify'ın "Add-to-cart limit" ayarı (Admin > Settings > Checkout) yalnızca
     * checkout adımında uygulanır; /cart/add.js ve /cart/change.js bu ayarı
     * dikkate almaz ve Shopify değeri Liquid'e de açmaz. Bu yüzden limit
     * mağaza ayarından (settings.cart_max_qty) okunup burada uygulanır.
     * Admin'deki sayı değişirse tema ayarındaki sayı da güncellenmelidir.
     */
    maxQty: function () {
      const value = parseInt(window.theme && window.theme.cartMaxQty);
      return value > 0 ? value : Infinity;
    },

    limitMessage: function () {
      return 'Bu üründen sepetinize en fazla ' + this.maxQty() + ' adet ekleyebilirsiniz.';
    },

    /**
     * Sepette bu varyanttan hâlihazırda kaç adet olduğunu döner
     */
    getVariantQty: async function (variantId) {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const line = cart.items.find(item => String(item.variant_id) === String(variantId));
      return line ? line.quantity : 0;
    },

    /**
     * Sepete ekleme için tek giriş noktası.
     * PDP formu ve tüm hızlı ekle (PLP, bundle, öne çıkanlar) butonları buradan geçer,
     * böylece limit tek yerde uygulanır.
     *
     * Limiti aşan kısım Shopify'a gönderilmez; Shopify'ın kendi hataları
     * (stok yetersizliği vb.) olduğu gibi kullanıcıya iletilir.
     */
    addVariant: async function (variantId, quantity) {
      let qty = parseInt(quantity) || 1;
      const max = this.maxQty();
      let limitReached = false;

      if (max !== Infinity) {
        const room = max - (await this.getVariantQty(variantId));

        if (room <= 0) {
          this.showNotice(this.limitMessage());
          return { ok: false, limited: true };
        }

        if (qty > room) {
          qty = room;
          limitReached = true;
        }
      }

      const response = await fetch(window.theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      });

      if (!response.ok) {
        // Shopify'ın kendi mesajını (stok vb.) olduğu gibi göster
        let msg = 'Ürün sepete eklenemedi.';
        try {
          const err = await response.json();
          msg = err?.description || err?.message || msg;
        } catch (_) { }

        this.showNotice(msg);
        return { ok: false };
      }

      await this.updateCartCount();
      if (limitReached) this.showNotice(this.limitMessage());

      return { ok: true, limited: limitReached };
    },

    /**
     * Add product to cart (PDP formu)
     */
    addToCart: async function (form) {
      const submitButton = form.querySelector('[type="submit"]');
      const originalText = submitButton.textContent;

      try {
        submitButton.disabled = true;
        submitButton.classList.add('loading');

        const formData = new FormData(form);
        const result = await this.addVariant(
          formData.get('id'),
          parseInt(formData.get('quantity')) || 1
        );

        if (!result.ok) return;

        submitButton.textContent = window.theme.strings.addedToCart || 'Added!';

        // Open cart drawer (cart sayfasında değilse)
        const isCartPage = window.location.pathname.includes('/cart');
        if (!isCartPage) {
          setTimeout(() => {
            this.openDrawer();
          }, 500);
        }

      } catch (error) {
        console.error('Add to cart error:', error);
        this.showNotice('Ürün sepete eklenirken bir sorun oluştu.');
      } finally {
        submitButton.disabled = false;
        submitButton.classList.remove('loading');

        setTimeout(() => {
          submitButton.textContent = originalText;
        }, 2000);
      }
    },

    /**
     * Update cart count bubble
     */
    updateCartCount: async function () {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();

        this.countBubbles.forEach(bubble => {
          bubble.textContent = '(' + cart.item_count + ')';
          bubble.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });

        window.theme.cartCount = cart.item_count;

      } catch (error) {
        console.error('Update cart count error:', error);
      }
    },

    /**
     * Change item quantity
     */
    changeQuantity: async function (button, change) {
      const lineItem = button.closest('[data-cart-item]');
      const key = lineItem.dataset.cartItem;
      const quantityInput = lineItem.querySelector('[data-quantity-input]');
      const currentQty = parseInt(quantityInput.value) || 0;

      // Limit dolduysa isteği hiç göndermeden uyar
      if (change > 0 && currentQty >= this.maxQty()) {
        this.showNotice(this.limitMessage());
        // Kutu her durumda sepetteki gerçek adedi göstersin
        quantityInput.value = currentQty;
        return;
      }

      this.setFooterLoading(true);
      await this.updateItem(key, Math.max(0, currentQty + change));
    },

    /**
     * Update cart item quantity
     */
    updateItem: async function (key, quantity) {
      this.setDrawerLoading(true);
      try {
        this.clearNotice();
        const response = await fetch(window.theme.routes.cart_change_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity })
        });

        if (!response.ok) {
          // Shopify hata mesajını yakala
          let msg = 'Stok limitine ulaşıldı.';
          try {
            const err = await response.json();
            msg = err?.description || err?.message || msg;
          } catch (_) { }

          this.showNotice(msg);

          // Shopify quantity'yi geri düzelttiği için drawer'ı refresh et
          await this.refreshMainCart();
          await this.refreshDrawer();
          return;
        }

        // Refresh cart drawer content
        await this.refreshMainCart();
        await this.refreshDrawer();

      } catch (error) {
        console.error('Update cart error:', error);
      } finally {
        this.setDrawerLoading(false);
      }
    },

    /**
     * Remove item from cart
     */
    removeItem: async function (key) {
      await this.updateItem(key, 0);
    },

    /**
     * Refresh cart drawer content
     */
    refreshDrawer: async function () {
      if (!this.drawer) return;

      try {
        const response = await fetch('/?section_id=cart-drawer');
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newContent = doc.querySelector('[data-cart-drawer-content]');

        if (newContent) {
          const currentContent = this.drawer.querySelector('[data-cart-drawer-content]');
          if (currentContent) {
            currentContent.innerHTML = newContent.innerHTML;
          }
        }

        await this.updateCartCount();

      } catch (error) {
        console.error('Refresh cart error:', error);
      }
    },
    /**
     * Sepet sayfasını tazele.
     *
     * Bölümün tamamı değiştirilir, çünkü ürün listesi, özet kutusu ve boş
     * sepet ekranı aynı bölümün içinde. Eskiden yalnızca ürün listesi
     * ([data-main-cart-content]) değiştiriliyordu ve bu iki soruna yol
     * açıyordu:
     *
     *   · Son ürün silindiğinde bölüm "boş sepet" dalını basıyor; o dalda
     *     [data-main-cart-content] hiç bulunmadığı için güncelleme sessizce
     *     atlanıyor ve silinen satır ekranda kalmaya devam ediyordu. Ürün
     *     sunucuda silinmiş olmasına rağmen kullanıcı "silme çalışmıyor"
     *     görüyordu.
     *   · Ara toplam özet kutusunda, yani listenin dışında durduğu için
     *     silme ve adet değişikliklerinden sonra eski tutarı gösteriyordu.
     *
     * Bölümün dışındaki <style> ve <script> blokları bilerek alınmıyor:
     * yeniden eklenseler kupon dinleyicisi ikinci kez bağlanırdı. Kupon
     * kutusu bu yüzden belgeye bağlı (delege) dinleyici kullanıyor.
     */
    refreshMainCart: async function () {
      const current = document.getElementById('main-cart');
      if (!current) return; // sepet sayfasında değilsek çık

      try {
        const response = await fetch('/?section_id=main-cart');
        const html = await response.text();

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const next = doc.getElementById('main-cart');

        if (next) {
          current.innerHTML = next.innerHTML;
        }
      } catch (error) {
        console.error('Refresh main cart error:', error);
      }
    },
  getNoticeElements: function () {
  const els = [];
  const mainEl = document.querySelector('#main-cart [data-cart-notice]');
  if (mainEl) els.push(mainEl);

  if (this.drawer) {
    const drawerEl = this.drawer.querySelector('[data-cart-notice]');
    if (drawerEl) els.push(drawerEl);
  }

  return els;
},

showNotice: function (message) {
  const els = this.getNoticeElements();
  if (!els.length) return;

  els.forEach(el => {
    el.textContent = message;
    el.classList.add('is-visible');
  });

  clearTimeout(this._noticeTimer);
  this._noticeTimer = setTimeout(() => {
    els.forEach(el => {
      el.classList.remove('is-visible');
      el.textContent = '';
    });
  }, 4000);
},

clearNotice: function () {
  const els = this.getNoticeElements();
  if (!els.length) return;

  els.forEach(el => {
    el.classList.remove('is-visible');
    el.textContent = '';
  });
},


    /**
     * Open cart drawer
     */
    openDrawer: function () {
      if (!this.drawer) return;

      // Cart sayfasındaysa drawer'ı açma
      const isCartPage = window.location.pathname.includes('/cart');
      if (isCartPage) {
        console.log('Cart sayfasında - drawer açılmıyor');
        return;
      }

      this.drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';

      if (this.overlay) {
        this.overlay.classList.add('is-visible');
      }

      this.refreshDrawer();
      Utils.trapFocus(this.drawer);
    },

    /**
     * Close cart drawer
     */
    closeDrawer: function () {
      if (!this.drawer) return;

      this.drawer.classList.remove('is-open');
      document.body.style.overflow = '';

      if (this.overlay) {
        this.overlay.classList.remove('is-visible');
      }
    },

    setFooterLoading: function (isLoading) {
      if (!this.drawer) return;
      const btns = this.drawer.querySelectorAll('[data-cart-footer-btn]');
      btns.forEach((btn) => {
        btn.classList.toggle('is-loading', isLoading);
        btn.textContent = 'Updating!';
        // a tag disable olmaz, o yüzden aria + pointer-events css ile
        if (btn.tagName === 'BUTTON') btn.disabled = isLoading;
        btn.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      });
    },
    setDrawerLoading: function (isLoading) {
      if (!this.drawer) return;
      this.drawer.classList.toggle('is-loading', isLoading);
    },

  };

  /**
   * ============================================
   * 4. QUANTITY SELECTORS
   * ============================================
   */

  const QuantitySelector = {
    init: function () {
      document.addEventListener('click', (e) => {
        /* Sepet satırlarının adedini Cart yönetir (sunucuya yazar ve içeriği
           yeniler). Burada da artırmak, limit nedeniyle istek gönderilmediğinde
           kutunun gerçek adetten sapmasına yol açıyordu. */
        if (e.target.closest('[data-cart-item]')) return;

        if (e.target.matches('[data-quantity-minus]')) {
          this.decrease(e.target);
        }
        if (e.target.matches('[data-quantity-plus]')) {
          this.increase(e.target);
        }
      });

      document.addEventListener('change', (e) => {
        if (e.target.matches('[data-quantity-input]')) {
          this.validate(e.target);
        }
      });
    },

    decrease: function (button) {
      const input = button.parentElement.querySelector('[data-quantity-input]');
      const min = parseInt(input.min) || 1;
      const current = parseInt(input.value);

      if (current > min) {
        input.value = current - 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    },

    increase: function (button) {
      const input = button.parentElement.querySelector('[data-quantity-input]');
      const max = parseInt(input.max) || Infinity;
      const current = parseInt(input.value);

      if (current < max) {
        input.value = current + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    },

    validate: function (input) {
      const min = parseInt(input.min) || 1;
      const max = parseInt(input.max) || Infinity;
      let value = parseInt(input.value);

      if (isNaN(value) || value < min) {
        input.value = min;
      } else if (value > max) {
        input.value = max;
      }
    }
  };

  /**
   * ============================================
   * 5. LAZY LOADING IMAGES
   * ============================================
   */

  const LazyLoad = {
    init: function () {
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                this.loadImage(entry.target);
                this.observer.unobserve(entry.target);
              }
            });
          },
          { rootMargin: '50px' }
        );

        this.observe();
      } else {
        // Fallback for older browsers
        this.loadAllImages();
      }
    },

    observe: function () {
      const lazyImages = document.querySelectorAll('[data-lazy-src]');
      lazyImages.forEach(img => this.observer.observe(img));
    },

    loadImage: function (img) {
      const src = img.dataset.lazySrc;
      if (src) {
        img.src = src;
        img.removeAttribute('data-lazy-src');
        img.classList.add('loaded');
      }
    },

    loadAllImages: function () {
      const lazyImages = document.querySelectorAll('[data-lazy-src]');
      lazyImages.forEach(img => this.loadImage(img));
    }
  };

  /**
   * ============================================
   * 6. HEADER SCROLL BEHAVIOR
   * ============================================
   */

  const Header = {
    init: function () {
      this.header = document.querySelector('[data-header]');
      if (!this.header) return;

      this.lastScroll = 0;
      this.bindEvents();
    },

    bindEvents: function () {
      window.addEventListener('scroll', Utils.throttle(() => {
        this.handleScroll();
      }, 100));
    },

    handleScroll: function () {
      const currentScroll = window.pageYOffset;

      // Add scrolled class for styling
      if (currentScroll > 100) {
        this.header.classList.add('is-scrolled');
      } else {
        this.header.classList.remove('is-scrolled');
      }

      // Hide/show header on scroll (optional)
      if (currentScroll > this.lastScroll && currentScroll > 300) {
        this.header.classList.add('is-hidden');
      } else {
        this.header.classList.remove('is-hidden');
      }

      this.lastScroll = currentScroll;
    }
  };

  /**
   * ============================================
   * 7. GLM2 FADE-IN OBSERVER
   * ============================================
   */

  const FadeInObserver = {
    init: function () {
      if (!('IntersectionObserver' in window)) {
        document.querySelectorAll('.fi').forEach(el => el.classList.add('in'));
        return;
      }
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

      document.querySelectorAll('.fi').forEach(el => observer.observe(el));

      /* Tema editöründe bir ayar değişince bölüm yeniden basılıyor. Yeni
         .fi elemanları izlenmediği için opacity 0'da kalıyor ve bölüm boş
         görünüyordu; yeniden basılan bölümdekiler hemen görünür yapılır. */
      document.addEventListener('shopify:section:load', (event) => {
        event.target.querySelectorAll('.fi').forEach(el => el.classList.add('in'));
      });
    }
  };

  /**
   * ============================================
   * 8. INITIALIZE ALL MODULES
   * ============================================
   */

  function init() {
    MobileMenu.init();
    Cart.init();
    QuantitySelector.init();
    LazyLoad.init();
    Header.init();
    FadeInObserver.init();

    /* Back to Top */
    var btt = document.getElementById('btt');
    if (btt) {
      window.addEventListener('scroll', Utils.throttle(function() {
        btt.classList.toggle('show', window.pageYOffset > 600);
      }, 200));
    }

    console.log('🚀 Glame GLM2 Theme Initialized');
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose utilities globally if needed
  window.GlameTheme = {
    Utils,
    Cart,
    MobileMenu
  };

})();
